import { Checkbox, FormControlLabel } from '@material-ui/core';
import { noop } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

class CheckboxWrapper extends React.Component {
  handleChange = e => {
    this.props.field.onChange(e);
    this.props.onChange(e);
  };

  render() {
    const { color, field, id, label, ...rest } = this.props;

    return (
      <FormControlLabel
        control={
          <Checkbox
            {...rest}
            {...field}
            checked={field.value}
            color={color}
            onChange={this.handleChange}
            value={id}
          />
        }
        label={label}
      />
    );
  }
}

CheckboxWrapper.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,

  color: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onChange: PropTypes.func,
  paths: PropTypes.array,
};

CheckboxWrapper.defaultProps = {
  color: 'primary',
  label: '',
  onChange: noop,
  paths: [],
};

export default CheckboxWrapper;



// WEBPACK FOOTER //
// ./src/modules/common/form/CheckboxWrapper.js